
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "whats-new-in-apache-atlas-10"
    }}>{`What's new in Apache Atlas 1.0?`}</h1>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul">{`Introduction of relationships as a first-class type`}</li>
      <li parentName="ul">{`Support for propagation of classifications along entity relationships – like lineage`}</li>
      <li parentName="ul">{`Fine-grained metadata security, which enables access controls up to entity instance level`}</li>
      <li parentName="ul">{`Introduction of Glossary feature`}</li>
      <li parentName="ul">{`Introduction of V2 style notifications`}</li>
      <li parentName="ul">{`Introduction of Atlas hook for HBase`}</li>
      <li parentName="ul">{`Support for Cassandra and Elasticsearch (tech-preview)`}</li>
    </ul>
    <h2 {...{
      "id": "updates"
    }}>{`Updates`}</h2>
    <ul>
      <li parentName="ul">{`Graph store has been updated from Titan 0.5.4 to JanusGraph 0.2.0`}</li>
      <li parentName="ul">{`DSL rewrite, to replace use of Scala based implementation with ANTLR`}</li>
      <li parentName="ul">{`Performance improvements in Atlas Hooks, by switching to use V2 style notifications`}</li>
      <li parentName="ul">{`Significant updates in Atlas Web UI`}</li>
    </ul>
    <h2 {...{
      "id": "changes"
    }}>{`Changes`}</h2>
    <h3 {...{
      "id": "dsl-search"
    }}>{`DSL search`}</h3>
    <p>{`With DSL rewrite and simplification, some older constructs may not work. Here's a list of behavior changes from previous
releases. More DSL related changes can be found `}<a parentName="p" {...{
        "href": "#/SearchAdvance"
      }}>{`here`}</a>{`.`}</p>
    <ul>
      <li parentName="ul">{`When filtering or narrowing results using string attribute, the value `}<strong parentName="li">{`MUST`}</strong>{` be enclosed in double quotes`}
        <ul parentName="li">
          <li parentName="ul">{`Table name="Table1"`}</li>
          <li parentName="ul">{`Table where name="Table1"`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Join queries are no longer supported e.g. hive_table, hive_db`}</li>
      <li parentName="ul">{`Select clauses only work with immediate entity attributes or a single referred (entity) type.`}
        <ul parentName="li">
          <li parentName="ul">{`Table select name, owner`}</li>
          <li parentName="ul">{`Table select Columns`}</li>
          <li parentName="ul">{`Table select name, owner, Columns `}<em parentName="li"><em parentName="em">{`(won't work)`}</em></em></li>
        </ul>
      </li>
      <li parentName="ul">{`OrderBy clause can only be used with a `}<em parentName="li"><em parentName="em">{`single primitive`}</em></em>{` attribute.`}</li>
      <li parentName="ul">{`GroupBy clause can only be used with a `}<em parentName="li"><em parentName="em">{`single primitive`}</em></em>{` attribute.`}
        <ul parentName="li">
          <li parentName="ul">{`Table groupby name`}</li>
          <li parentName="ul">{`Table groupby Columns (won't work)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Typename can't have multiple aliases`}
        <ul parentName="li">
          <li parentName="ul">{`Table as t (OK)`}</li>
          <li parentName="ul">{`Table as t1, t2 (won't work)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Has clause only works with primitive attributes.`}
        <ul parentName="li">
          <li parentName="ul">{`Table has name`}</li>
          <li parentName="ul">{`Table has Columns or Table has DB (NOT supported)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Aggregator clause can only be used with a `}<em parentName="li"><em parentName="em">{`single primitive`}</em></em>{` attribute.`}
        <ul parentName="li">
          <li parentName="ul">{`Table select min(name)`}</li>
          <li parentName="ul">{`Table select max(name)`}</li>
          <li parentName="ul">{`Table select sum(createTime)`}</li>
          <li parentName="ul">{`Table select min(Columns) (won't work)`}</li>
          <li parentName="ul">{`Table select max(Columns) (won't work)`}</li>
          <li parentName="ul">{`Table select sum(Columns) (won't work)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Aggregator clause can't be repeated with different `}<em parentName="li"><em parentName="em">{`primitive attribute`}</em></em>{`, the clause appearing last would take preference.`}
        <ul parentName="li">
          <li parentName="ul">{`Table select min(name), min(createTime) will ignore `}<em parentName="li"><em parentName="em">{`min(name)`}</em></em></li>
        </ul>
      </li>
      <li parentName="ul">{`Limit and offset are not applicable when using aggregator clauses (min, max, sum)`}
        <ul parentName="li">
          <li parentName="ul">{`Table select min(name) limit 10 offset 5 - min(name) is computed over `}<strong parentName="li">{`ALL`}</strong>{` entities of type Asset`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;